module.exports = __webpack_public_path__ + "img/fish-stew.95c9f728.jpg";